
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "Page401"
})
export default class extends Vue {
  private ewizardClap =
    "https://wpimg.wallstcn.com/007ef517-bafd-4066-aae4-6883632d9646";
  private dialogVisible = false;

  private back() {
    if (this.$route.query.noGoBack) {
      this.$router.push({ path: "/dashboard" });
    } else {
      this.$router.go(-1);
    }
  }
}
